/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ImageWithCoordinates } from '../../models/image-with-coordinates';
import { UpdateNoteCommandResult } from '../../models/update-note-command-result';

export interface ApiKpiReportsUpdateNotePost$Plain$Params {
      body?: {
'Id'?: string;
'KPIId'?: string;
'Notes'?: string;
'Attachments'?: Array<Blob>;
'Images'?: Array<ImageWithCoordinates>;
'Lat'?: number;
'Lng'?: number;
}
}

export function apiKpiReportsUpdateNotePost$Plain(http: HttpClient, rootUrl: string, params?: ApiKpiReportsUpdateNotePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateNoteCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiKpiReportsUpdateNotePost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateNoteCommandResult>;
    })
  );
}

apiKpiReportsUpdateNotePost$Plain.PATH = '/api/KPIReports/UpdateNote';
